import React, { useEffect, useState } from 'react';
import QuizResults from '../components/QuizResults';
import { useSelector } from 'react-redux';
import { RootState } from '../store/Store';
import { Link } from 'react-router-dom';
import QuizResultsProgressbar from '../components/QuizResultsProgressbar';
import { usePageMeta } from '../hooks/usePageMeta';
import './QuizResultsPage.css';

const QuizResultsPage: React.FC = () => {
  usePageMeta('Exam results', 'View your Danish citizenship practice exam results.');
  const quizData = useSelector((state: RootState) => state.quiz);

  const [totalCorrect, setTotalCorrect] = useState<number>(0);
  const [totalQuestions, setTotalQuestions] = useState<number>(0);
  const minimumCorrect = 20;

  useEffect(() => {
    window.scrollTo(0, 0);
    setTotalQuestions(0)
    setTotalCorrect(0)
    for (const index in quizData.questions) {
      setTotalQuestions(prevCount => prevCount + 1)

      const question = quizData.questions;
      if (question[index].answer === quizData.userAnswers[index]) {
        setTotalCorrect(prevCount => prevCount + 1)
      }
    }
  }, [quizData]);

  return (
    <div className='quiz-results-page-container'>
      <Link to="/projects/vejen-til-dansk-statsborgerskab" className="quiz-back-link">
        <span className="quiz-back-arrow">←</span>
        <span>Back to home</span>
      </Link>
      <div className="quiz-results-content">
        <div className="quiz-results-header">
          <QuizResultsProgressbar total={totalQuestions} totalCorrect={totalCorrect} minCorrect={minimumCorrect} />
          <h1 className="quiz-results-title">
            {totalCorrect >= minimumCorrect ? "Tilykke. Du har bestået." : "Desværre. Du har ikke bestået."}
          </h1>
        </div>
        <QuizResults data={quizData} />
      </div>
    </div>
  );
};

export default QuizResultsPage;
